/**
 * Wire shapes for /api/v2/admin/content/services.
 *
 * Cycle-12 BE projects the legacy GQL fragment 1:1 — list rows are
 * locale-picked (jsonb columns → string via @Lang()), detail rows pass
 * jsonb through so the per-locale form binds each language directly.
 *
 * Phase E Cycle 4 — status + type now canonical BE enum strings.
 */

// Phase E Cycle 4 canonical (BE catalog.constants).
export enum ServiceStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export enum ServiceType {
  Radiology = 'radiology',
  VideoCall = 'video_call',
  Department = 'department',
  Treatment = 'treatment',
  FindDoctor = 'find_doctor',
  Other = 'other'
}

export interface ServiceOrganizationLink {
  id: number;
  name: string;
}

export interface ServiceListRow {
  id: number;
  slug: string;
  type: ServiceType | null;
  status: ServiceStatus | null;
  title: string;
  short_desc: string;
  description: string;
  keywords: string;
  link: string | null;
  img: string | null;
  organization: ServiceOrganizationLink | null;
}

export interface ServiceListResponse {
  results: ServiceListRow[];
  total: number;
}

export interface ServiceDetail {
  id: number;
  slug: string;
  title: Record<string, string>;
  description: Record<string, string>;
  short_desc: Record<string, string> | null;
  keywords: Record<string, string>;
  subtitle: Record<string, string>;
  text: Record<string, string>;
  status: ServiceStatus | null;
  type: ServiceType | null;
  parent_id: number | null;
  main_image: string | null;
  img: string | null;
  icon: string | null;
  img_mobile: string | null;
  link: string | null;
  sort_index: number | null;
  created_at: string;
  updated_at: string;
  doctor_ids?: number[];
}

export interface ServiceListQuery {
  page?: number; // 0-based on the FE; service coerces to 1-based BE
  limit?: number;
  name?: string;
  lang?: string;
}

export interface ServiceInput {
  slug?: string;
  title?: Record<string, string>;
  description?: Record<string, string>;
  short_desc?: Record<string, string>;
  keywords?: Record<string, string>;
  subtitle?: Record<string, string>;
  text?: Record<string, string>;
  status?: ServiceStatus;
  type?: ServiceType;
  parent_id?: number;
  sort_index?: number;
  main_image?: string;
  img?: string;
  icon?: string;
  img_mobile?: string;
  link?: string;
}

export interface AttachServiceDoctorsInput {
  service_id: number;
  doctor_ids: number[];
}
